const layout = ['_ZXCV', 'ASDFG', 'QWERT', '12345', '09876', 'POIUY', '_LKJH', '__MNB'];
const positions = new Map();
layout.forEach((row, r) => [...row].forEach((key, c) => { if (key !== '_') positions.set(key, [r, c]); }));
const special = {
  Enter: [6, 0], Space: [7, 0], ShiftLeft: [0, 0], ShiftRight: [0, 0], ControlLeft: [7, 1], ControlRight: [7, 1],
  Backspace: [4, 0, 'caps'], Escape: [7, 0, 'caps'], Tab: [7, 1, 'caps'], Home: [3, 0, 'caps'],
  CapsLock: [3, 1, 'caps'], PageUp: [3, 2, 'caps'], PageDown: [3, 3, 'caps'], Insert: [4, 1, 'caps'],
};
const punctuation = { '!': '1', '@': '2', '#': '3', '$': '4', '%': '5', '&': '6', "'": '7', '(': '8', ')': '9', '_': '0', '<': 'R', '>': 'T', '[': 'Y', ']': 'U', ';': 'O', '"': 'P', '{': 'F', '}': 'G', '^': 'H', '-': 'J', '+': 'K', '=': 'L', ':': 'Z', '£': 'X', '?': 'C', '/': 'V', '*': 'B', ',': 'N', '.': 'M' };
const ext = { ArrowLeft: 16384, ArrowRight: 8192, ArrowUp: 2, ArrowDown: 32768, Escape: 64, Backspace: 4096, Tab: 1, Home: 128, CapsLock: 4, Insert: 8, PageUp: 16, PageDown: 32 };

export class Keyboard {
  constructor(machine, mode = machine === 'next' ? 'next' : 'sinclair') { this.machine = machine; this.mode = mode; this.held = new Map(); }
  set(code, key, pressed) {
    if (!pressed) return this.held.delete(code);
    let binding = special[code];
    if (code.startsWith('Key')) binding = positions.get(code.slice(3));
    if (code.startsWith('Digit')) binding = positions.get(code.slice(5));
    if (punctuation[key]) binding = [...positions.get(punctuation[key]), 'sym'];
    const arrows = this.mode === 'next' ? { ArrowLeft: '8', ArrowRight: '9', ArrowUp: '7', ArrowDown: '6' } : { ArrowLeft: '6', ArrowRight: '9', ArrowUp: '8', ArrowDown: '7' };
    if (arrows[code] && this.mode !== 'kempston') binding = positions.get(arrows[code]);
    const cursor = this.mode === 'cursor' && { ArrowLeft: '5', ArrowRight: '8', ArrowUp: '7', ArrowDown: '6' }[code];
    if (cursor) binding = [...positions.get(cursor), 'caps'];
    const joystick = this.mode === 'kempston' ? ({ ArrowRight: 1, ArrowLeft: 2, ArrowDown: 4, ArrowUp: 8, Space: 16, AltLeft: 16, AltRight: 16 }[code] ?? 0) : 0;
    if (!binding && !ext[code] && !joystick) return false;
    if (joystick) binding = null;
    this.held.set(code, { binding, extended: cursor ? 0 : ext[code] ?? ({ ';': 256, '"': 512, ',': 1024, '.': 2048 }[key] ?? 0), joystick });
    return true;
  }
  clear() { this.held.clear(); }
  state() {
    const rows = new Uint8Array(8).fill(255);
    const extendedRows = new Uint8Array(8).fill(255);
    let extended = 0, joystick = 0;
    for (const held of this.held.values()) {
      if (held.binding) {
        const [r, c, modifier] = held.binding;
        const matrix = this.machine === 'next' && held.extended ? extendedRows : rows;
        matrix[r] &= ~(1 << c);
        if (modifier === 'caps') matrix[0] &= ~1;
        if (modifier === 'sym') matrix[7] &= ~2;
      }
      extended |= held.extended;
      joystick |= held.joystick;
    }
    return { rows, extendedRows, extended, joystick };
  }
}

export function gamepadButtons(pad) {
  if (!pad) return 0;
  const pressed = index => pad.buttons[index]?.pressed;
  return ((pad.axes[0] > .4 || pressed(15)) ? 1 : 0) | ((pad.axes[0] < -.4 || pressed(14)) ? 2 : 0)
    | ((pad.axes[1] > .4 || pressed(13)) ? 4 : 0) | ((pad.axes[1] < -.4 || pressed(12)) ? 8 : 0)
    | (pressed(0) ? 16 : 0) | (pressed(1) ? 32 : 0) | (pressed(2) ? 64 : 0) | (pressed(9) ? 128 : 0);
}
